<template>
  <div v-if="project">
    <!-- User Info: Input Fields -->
    <b-card>
      <b-card-body class="p-0">
        <b-form
          v-if="project.isChildren || (!project.isChildren && !isUserLimitedProjects)"
          class="mt-1"
        >
          <b-row>
            <b-col
              cols="12"
              md="6"
            >
              <b-form-group
                :label="$t(project.isChildren ? 'projects.sad-name' : 'projects.project-name')"
                label-for="project-name"
              >
                <b-form-input
                  id="project-name"
                  v-model="project.projectName"
                />
              </b-form-group>
            </b-col>

            <b-col
              v-if="!project.isChildren"
              cols="12"
              md="6"
            >
              <b-form-group
                :label="$t('projects.external-name')"
                label-for="external-name"
              >
                <b-form-input
                  id="external-name"
                  v-model="project.infos.externalName"
                />
              </b-form-group>
            </b-col>

            <!-- Field: Project Code  -->
            <b-col
              cols="12"
              md="2"
            >
              <b-form-group
                :label="$t('projects.' + (project.isChildren ? 'sad' : 'project') +'-code')"
                label-for="project-code"
              >
                <b-form-input
                  id="project-code"
                  v-model="project.infos.projectCode"
                />
              </b-form-group>
            </b-col>
            <!-- Field: Status -->
            <b-col
              cols="12"
              md="4"
            >
              <b-form-group
                :label="$t('projects.filter-status-label')"
                label-for="user-status"
              >
                <v-select
                  v-model="project.infos.status"
                  :options="lookupOptions.statusOptions"
                  :reduce="val => val.label"
                  taggable
                  push-tags
                  input-id="user-status"
                />
              </b-form-group>
            </b-col>

            <!-- Field: Project Type -->
            <b-col
              v-if="!project.isChildren"
              cols="12"
              md="6"
            >
              <b-form-group
                :label="$t('projects.filter-project-type')"
                label-for="project-type"
              >
                <v-select
                  v-model="project.infos.projectType"
                  :options="lookupOptions.projectTypeOptions"
                  :reduce="val => val.label"
                  taggable
                  push-tags
                  input-id="project-type"
                />
              </b-form-group>
            </b-col>
            <!-- Field: Mission  -->
            <b-col
              cols="12"
              md="3"
            >
              <b-form-group
                :label="$t('projects.filter-missions-label')"
                label-for="mission"
              >
                <v-select
                  v-model="project.infos.missionName"
                  :options="lookupOptions.missionOptions"
                  :reduce="val => val.label"
                  taggable
                  push-tags
                  input-id="mission"
                />
              </b-form-group>
            </b-col>

            <!-- Field: Nation  -->
            <b-col
              cols="12"
              md="3"
            >
              <b-form-group
                :label="$t('projects.filter-nations-label')"
                label-for="nation"
              >
                <v-select
                  v-model="project.infos.nation"
                  :options="lookupOptions.nationsOptions"
                  :reduce="val => val.label"
                  taggable
                  push-tags
                  input-id="nation"
                />
              </b-form-group>
            </b-col>

            <!-- Field: Triboo  -->
            <b-col
              v-if="project.isChildren"
              cols="12"
              md="3"
            >
              <b-form-group
                :label="$t('projects.triboo')"
                label-for="triboo"
              >
                <v-select
                  v-model="project.infos.triboo"
                  :options="lookupOptions.tribooOptions"
                  :reduce="val => val.label"
                  taggable
                  push-tags
                  input-id="triboo"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="project.isChildren">
            <!-- Field: Birth Date -->
            <b-col
              cols="12"
              md="3"
              lg="3"
            >
              <b-form-group
                :label="$t('projects.birth-date')"
                label-for="birth-date"
              >
                <date-picker-input
                  id="birth-date"
                  v-model="project.infos.birthDate"
                />
              </b-form-group>

            </b-col>

            <!-- Field: Gender -->
            <b-col
              cols="12"
              md="3"
              lg="3"
            >
              <b-form-group
                :label="$t('projects.gender')"
                label-for="gender"
                label-class="mb-1"
              >
                <b-form-radio-group
                  id="gender"
                  v-model="project.infos.gender"
                  :options="genderOptions"
                />
              </b-form-group>
            </b-col>

            <!-- Field: School Class  -->
            <b-col
              cols="12"
              md="6"
            >
              <b-form-group
                :label="$t('projects.school-class')"
                label-for="school-class"
              >
                <b-form-input
                  id="school-class"
                  v-model="project.infos.schoolClass"
                />
              </b-form-group>
            </b-col>

            <!-- Field: Address Line -->
            <b-col
              cols="12"
              md="9"
              lg="9"
            >
              <b-form-group
                :label="$t('projects.address-line')"
                label-for="address-line-1"
              >
                <b-form-input
                  id="address-line-1"
                  v-model="project.infos.addressLine"
                />
              </b-form-group>
            </b-col>

          </b-row>

          <b-row v-if="!project.isChildren">
            <!-- Field: Project Date -->
            <b-col
              cols="12"
              md="2"
            >
              <b-form-group
                :label="$t('projects.project-date')"
                label-for="project-date"
              >
                <date-picker-input
                  id="project-date"
                  v-model="project.infos.projectDate"
                />
              </b-form-group>
            </b-col>

            <b-col
              cols="12"
              md="3"
            >
              <b-form-group
                :label="$t('projects.project-inspectory')"
                label-for="project-inspectory"
              >
                <b-form-input
                  id="project-inspectory"
                  v-model="project.infos.inspectory"
                />
              </b-form-group>
            </b-col>

            <b-col
              cols="12"
              md="3"
            >
              <b-form-group
                :label="$t('projects.project-zone')"
                label-for="project-zone"
              >
                <v-select
                  id="project-zone"
                  v-model="project.infos.zone"
                  :options="zoneOptions"
                />
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              md="4"
            >
              <b-form-group
                :label="$t('projects.web')"
                label-for="project-web"
              >
                <b-form-input
                  id="project-web"
                  v-model="project.infos.web"
                />
              </b-form-group>
            </b-col>

            <b-col
              cols="12"
              md="3"
            >
              <b-form-group
                :label="$t('projects.total-amount')"
                label-for="total-amount"
              >
                <currency-input
                  id="total-amount"
                  v-model="project.infos.totalAmount"
                  class="form-control"
                  placeholder="0,00"
                />
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              md="6"
              lg="3"
            >
              <b-form-group
                :label="$t('projects.total-currency')"
                label-for="total-currency"
                label-class="mb-1"
              >
                <b-form-radio-group
                  id="total-currency"
                  v-model="project.infos.totalCurrency"
                  :options="currencyOptions"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="!project.isChildren">
            <b-col
              cols="12"
              md="6"
            >
              <b-form-group
                :label="$t('projects.found-from')"
                label-for="found-from"
              >
                <b-form-textarea
                  id="found-from"
                  v-model="project.infos.foundFrom"
                  rows="3"
                />
              </b-form-group>
            </b-col>

            <b-col
              cols="12"
              md="6"
            >
              <b-form-group
                :label="$t('projects.referrals')"
                label-for="referrals"
              >
                <b-form-textarea
                  id="referrals"
                  v-model="project.infos.referrals"
                  rows="3"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="12"
              md="12"
              lg="12"
            >
              <hr>
            </b-col>
          </b-row>
        </b-form>
        <b-form>
          <b-row v-if="project.pid">
            <b-col
              cols="12"
              md="12"
              lg="12"
            >
              <attachments-edit
                v-model="project.attachments"
                :refaid="refaid"
                class="mt-2"
              />
            </b-col>
          </b-row>
        </b-form> </b-card-body></b-card>
  </div>
</template>

<script>

import {
  BRow, BCol, BFormGroup, BFormInput, BForm, BFormTextarea, BFormRadioGroup, BCardBody, BCard,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import authService from '@/vue.auth.service'
import lookupsService from '@/vue.lookups.service'
import CurrencyInput from '../layouts/CurrencyInput.vue'
import DatePickerInput from '../layouts/DatePickerInput.vue'
import AttachmentsEdit from '../attachments/AttachmentsEdit.vue'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BFormTextarea,
    BFormRadioGroup,
    vSelect,
    AttachmentsEdit,
    DatePickerInput,
    BCardBody,
    BCard,
    CurrencyInput,
  },
  props: {
    value: {
      type: Object,
      default: null,
    },
    // eslint-disable-next-line vue/require-prop-types
    refaid: {
      required: true,
    },
    lookupOptions: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isUserLimitedProjects: authService.isUserInRole('limit-projects'),
    }
  },
  computed: {
    project: {
      get() { return this.value },
      set(value) { this.$emit('input', value) },
    },
  },
  setup() {
    const genderOptions = lookupsService.getGenderOptions()
    const zoneOptions = lookupsService.getZoneOptions()
    const currencyOptions = lookupsService.getCurrencyOptions()
    return {
      genderOptions,
      zoneOptions,
      currencyOptions,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
